import { buildSvgPath } from "@/scripts/common/svg-path";

const element = document.querySelector(".element-steps");

const getLeftX = () => {
  const containerPadding = Math.min(75, (5.5 / 100) * window.innerWidth);
  const maxWidth = 1530;

  if (window.innerWidth < maxWidth + containerPadding) {
    return containerPadding / 2;
  }

  return (window.innerWidth - maxWidth) / 2;
};

const setupApplyPage = () => {
  if (!document.body.classList.contains("page-apply")) {
    return;
  }

  const pathContainer = document.body;

  const getPathPoints = () => {
    const pageHeaderTitle = pathContainer.querySelector(".page-header-title");
    const pageHeaderTitleRect = pageHeaderTitle.getBoundingClientRect();
    const pageHeaderTitleText = pageHeaderTitle.querySelector("h1");
    const pageHeaderTitleTextRect = pageHeaderTitleText.getBoundingClientRect();
    const stepItems = element.querySelector(".step-items");
    const stepItemsRect = stepItems.getBoundingClientRect();
    const stepTitle = stepItems.querySelector(".step-title");
    const stepTitleRect = stepTitle.getBoundingClientRect();
    const additionalY = stepTitle.closest("[data-sr-done]") ? 30 : 0;

    const leftX = getLeftX();

    const points = [];

    if (!window.matchMedia("(min-width: 768px)").matches) {
      return points;
    }

    points.push({ x: pageHeaderTitleTextRect.x - 48, y: pageHeaderTitleRect.y + pageHeaderTitleRect.height / 2 });
    points.push({ x: leftX, y: pageHeaderTitleRect.y + pageHeaderTitleRect.height / 2 });
    points.push({ x: leftX, y: stepTitleRect.y - 24 + additionalY + stepTitleRect.height / 2 });
    points.push({
      x: stepItemsRect.x + stepItemsRect.width - 24,
      y: stepTitleRect.y - 24 + additionalY + stepTitleRect.height / 2,
    });

    return points;
  };

  const handleSvgPath = () => {
    const pathPoints = getPathPoints();
    buildSvgPath(pathContainer, pathPoints);
  };

  const resizeObserver = new ResizeObserver(() => requestAnimationFrame(handleSvgPath));
  resizeObserver.observe(document.body);

  document.documentElement.addEventListener("dimensions:change", () => requestAnimationFrame(handleSvgPath));
};

const setupServicePage = () => {
  if (!document.body.classList.contains("pagetype-servicepage")) {
    return;
  }

  const pathContainer = document.body;

  const getPathPoints = () => {
    const pageHeader = pathContainer.querySelector(".page-header");
    const pageHeaderRect = pageHeader.getBoundingClientRect();
    const stepItems = element.querySelector(".step-items");
    const stepItemsRect = stepItems.getBoundingClientRect();
    const stepTitle = stepItems.querySelector(".step-title");
    const stepTitleRect = stepTitle.getBoundingClientRect();
    const additionalLeftX = window.matchMedia("(min-width: 1700px)").matches ? 48 : 0;
    const additionalY = stepTitle.closest("[data-sr-done]") ? 30 : 0;

    const leftX = getLeftX() - additionalLeftX;

    const points = [];

    if (!window.matchMedia("(min-width: 768px)").matches) {
      return points;
    }

    points.push({ x: leftX, y: pageHeaderRect.y + pageHeaderRect.height });
    points.push({ x: leftX, y: stepTitleRect.y - 24 + additionalY + stepTitleRect.height / 2 });
    points.push({
      x: stepItemsRect.x + stepItemsRect.width - 24,
      y: stepTitleRect.y - 24 + additionalY + stepTitleRect.height / 2,
    });

    return points;
  };

  const handleSvgPath = () => {
    const pathPoints = getPathPoints();
    buildSvgPath(pathContainer, pathPoints, { gradientId: "page-line-gradient-faded" });
  };

  const resizeObserver = new ResizeObserver(() => requestAnimationFrame(handleSvgPath));
  resizeObserver.observe(document.body);

  document.documentElement.addEventListener("dimensions:change", () => requestAnimationFrame(handleSvgPath));
};

const setupHomePage = () => {
  if (!document.body.classList.contains("pagetype-homepage")) {
    return;
  }

  const pathContainer = document.body;
  const mediaElement = document.querySelector(".element-largecontentmedia");

  if (!mediaElement) {
    return;
  }

  const getPathPoints = () => {
    const elementTitle = mediaElement.querySelector(".element-title");
    const elementTitleRect = elementTitle.getBoundingClientRect();
    const stepItems = element.querySelector(".step-items");
    const stepItemsRect = stepItems.getBoundingClientRect();
    const stepTitle = stepItems.querySelector(".step-title");
    const stepTitleRect = stepTitle.getBoundingClientRect();
    const additionalLeftX = window.matchMedia("(min-width: 1024px)").matches ? 48 : 0;
    const additionalY = elementTitle.closest("[data-sr-done]") ? 30 : 0;

    const points = [];

    if (!window.matchMedia("(min-width: 768px)").matches) {
      return points;
    }

    points.push({ x: elementTitleRect.x + additionalLeftX, y: elementTitleRect.y + elementTitleRect.height });
    points.push({
      x: elementTitleRect.x + additionalLeftX,
      y: stepTitleRect.y - 24 + additionalY + stepTitleRect.height / 2,
    });
    points.push({
      x: stepItemsRect.x + stepItemsRect.width - 24,
      y: stepTitleRect.y - 24 + additionalY + stepTitleRect.height / 2,
    });

    return points;
  };

  const handleSvgPath = () => {
    const pathPoints = getPathPoints();
    buildSvgPath(pathContainer, pathPoints, { gradientId: "page-line-gradient-faded" });
  };

  const resizeObserver = new ResizeObserver(() => requestAnimationFrame(handleSvgPath));
  resizeObserver.observe(document.body);

  document.documentElement.addEventListener("dimensions:change", () => requestAnimationFrame(handleSvgPath));
};

document.addEventListener("DOMContentLoaded", () => {
  if (!element) {
    return;
  }

  setupApplyPage();
  setupServicePage();
  setupHomePage();
});
